import React from 'react';

export const DevelopmentEnvironmentBanner: React.FC = () => {
  if (import.meta.env.VITE_ENV !== 'development') {
    return null;
  }

  return (
    <div
      role="note"
      aria-label="Ambiente de desenvolvimento"
      style={{
        width: '100%',
        background: 'linear-gradient(90deg, #b91c1c 0%, #dc2626 55%, #991b1b 100%)',
        color: '#fff7ed',
        textAlign: 'center',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.8,
        textTransform: 'uppercase',
        padding: '10px 16px',
        boxShadow: '0 -2px 8px rgba(127, 29, 29, 0.25)',
      }}
    >
      Ambiente de Desenvolvimento
    </div>
  );
};
